import {unref} from "vue";
import {deepClone, GoingNewUtils} from "xmgoing-utils";


export interface IKeyMap {
  oldKey: string;
  newKey: string;
}


export function getFormList(props){
  const targetObj = {targetList: []};
  if (props.pageConfigs && props.pageConfigs.blocks) {
    findCtls(props.pageConfigs.blocks, "xmForm", targetObj);
    findCtls(props.pageConfigs.blocks, "xmSubTable", targetObj);
    findCtls(props.pageConfigs.blocks, "materialsSel", targetObj);
    findCtls(props.pageConfigs.blocks, "xmQueryForm", targetObj);
  }
  const formList = [...targetObj.targetList, {model: {key: 'state'}, label: '全局状态'}];
  return formList;
}
/**
 * 获取表单元素
 * @param findItem
 * @param formElList
 */
const getFormElList = function (findItem, formElList) {
  if (findItem && findItem.props && findItem.props.isFormEl) {
    const dbItem=formElList.filter((itemDb)=>{
      if(itemDb.model&&findItem.model){
        return itemDb.model.key===findItem.model.key;
      }else{
        return false;
      }
    })[0];
    if(!dbItem){
      formElList.push(findItem);
    }
  }
  //如果是数组对象集合
  if (findItem && Array.isArray(findItem.children) && findItem.children.length > 0) {
    findItem.children.forEach((sonItem) => {
      getFormElList(sonItem, formElList);
    })
  }
}

export function getObjSonList({targetKey,formList}){
  const findItem: any = unref(formList).filter((itemDb) => {
    return itemDb.model&&(itemDb.model.key === targetKey);
  })[0];
  //如果目标是查询表单 或者 填写表单
  if (findItem && (findItem.componentKey === "xmForm" || findItem.componentKey === "xmQueryForm")) {
    const formElList = [];
    getFormElList(findItem, formElList);
    return formElList;
  }
  //如果目标是动态子表
  if (findItem && findItem.componentKey === "xmSubTable") {
    return findItem.dataConfig.columns;
  }
  //如果目标是动态子表
  if (findItem && findItem.componentKey === "materialsSel") {
    return findItem.dataConfig.columns;
  }
}
/**
 * 替换对象的key信息
 * @param infoSettingJsonObj
 */
export function changeTempCtlKeys(infoSettingJsonObj, keyChangMap) {
  if (infoSettingJsonObj && infoSettingJsonObj.blocks && Array.isArray(infoSettingJsonObj.blocks)) {
    infoSettingJsonObj.blocks.forEach((itemObj) => {
      changeListCtlKey(itemObj, keyChangMap);
    })
  }
  //变更key信息
  let infoSettingJsonObjStr = JSON.stringify(infoSettingJsonObj);
  keyChangMap.forEach((keyItem: IKeyMap) => {
    infoSettingJsonObjStr = replaceAll(infoSettingJsonObjStr, keyItem.oldKey, keyItem.newKey);
  })
  infoSettingJsonObj = JSON.parse(infoSettingJsonObjStr);
  return infoSettingJsonObj;
}

export function replaceAll(str, oldStr, newStr) {
  if (oldStr && (oldStr + '').length > 0) {
    const newStrTwo = str.replace(new RegExp(oldStr, 'g'), newStr);
    console.log(newStrTwo, "=======newStrTwo")
    return newStrTwo
  } else {
    return str;
  }
}

/**
 * 替换其中对象的key
 * @param itemObj
 */
export function changeListCtlKey(itemObj, keyChangMap) {
  const newKey = 'new' + GoingNewUtils.getUUChar(24);
  itemObj.key = newKey;
  itemObj._vid = newKey;
  if (itemObj.props) {
    if (itemObj.props.key && (itemObj.props.key + '').trim() && (itemObj.props.key + '').trim().length > 0) {
      keyChangMap.push({oldKey: itemObj.props.key, newKey});
    }
    itemObj.props['key'] = newKey;
  }
  if (itemObj.model) {
    if (itemObj.model['key'] === 'id' || itemObj.model['key'] === 'parentId' || itemObj.model['key'] === 'treeName') {
      return
    }
    itemObj.model['key'] = newKey;
  }

  if (itemObj && itemObj.children && Array.isArray(itemObj.children)) {
    itemObj.children.forEach((sonItem) => {
      changeListCtlKey(sonItem, keyChangMap);
    })
  }

  if (itemObj && itemObj.props && itemObj.props.rightSlotItem && Array.isArray(itemObj.props.rightSlotItem)) {
    itemObj.props.rightSlotItem.forEach((sonItem) => {
      changeListCtlKey(sonItem, keyChangMap);
    })
  }
}

/**
 * 对象组件json
 * @param ctlJson
 */
export const changCtlKey = function (ctlJson) {
  if (ctlJson) {
    const key = 'ctlCopy_' + GoingNewUtils.getUUChar(20);

  }
}

/**
 * 删除多余样式信息
 * @param styles
 * @param desElObj
 */
const delUnUseStyles = function (styles,desElObj) {
  const newStyles:any=deepClone(styles);
  if(newStyles&&typeof newStyles==='object'){
    //如果是单位样式 而且是px 则是多余属性 删除了
    Object.keys(newStyles).forEach((propName)=>{
      if(propName.indexOf("Unit")>0&&newStyles[propName]==='px'){
        delete newStyles[propName];
      }
    })
  }
  desElObj.styles=newStyles;
}

/**
 * 删除多余没有用的属性
 * @param props
 * @param desElObj
 */
const delUnUseProps=function (props,desElObj){
  const newProps:any=deepClone(props);
  if(newProps&&typeof newProps==='object'){
    //如果是单位样式 而且是px 则是多余属性 删除了
    Object.keys(newProps).forEach((propName)=>{
      if(newProps[propName]==null||newProps[propName]===''){
        delete newProps[propName];
      }
    })
  }
  desElObj.props=newProps;
}

/**
 * 清空对象里面没有必要的属性 减少保存的体积
 * @param list
 */
export function initMoreUnUseProps(list: any) {
  if (unref(list) && Array.isArray(unref(list))) {
    unref(list).forEach((desElObj: any) => {
      if (desElObj && desElObj.styles) {
        delUnUseStyles(desElObj.styles,desElObj);
        delUnUseProps(desElObj.props,desElObj);
      }
      if (desElObj && desElObj.children) {
        initMoreUnUseProps(desElObj.children);
      }
      if (desElObj && desElObj.tabDivConfig) {
        initMoreUnUseProps(desElObj.tabDivConfig);
      }
      if (desElObj && desElObj.props && desElObj.props.rightSlotItem) {
        initMoreUnUseProps(desElObj.props.rightSlotItem);
      }
      console.log(desElObj, "=====desElObj")
    })
  }
}

/**
 * 查找所有动态子表格记录集合
 * @param list
 */
export const findSubTableCtls=function (list){
  const targetObj: any = {targetList: []};
  //表格区域初始化
  findCtlsByType(list, "xmSubTable", targetObj);
  findCtlsByType(list, "materialsSel", targetObj);
  return targetObj.targetList;
}
export const findUnitChangeCtls=function (list){
  const targetObj: any = {targetList: []};
  //表格区域初始化
  findCtlsByType(list, "UnitChange", targetObj);
  return targetObj.targetList;
}
/**
 * 根据组件名称 获取组件集合
 * @param list
 * @param key
 * @param targetObj
 */
export const findCtls = function (list, key, targetObj,labelStr='',deepCloneFlag=true,winFlag=true) {
  try{
    if (unref(list) && Array.isArray(unref(list))) {
      const findItemList = unref(list).filter((itemDb) => {
        if (itemDb.sectionConfig) {
          if (key === '*Char' && itemDb.sectionConfig.ctlName.indexOf("Char") >= 0) {
            return true;
          } else {
            return itemDb.sectionConfig.ctlName === key;
          }
        } else {
          return itemDb.componentKey === key;
        }
      });
      if (findItemList && findItemList.length > 0) {
        findItemList.forEach((findItem) => {
          //兼容门户组件
          if (findItem.sectionConfig) {
            const borderProps:any = deepCloneFlag?deepClone(findItem.borderConfig):findItem.borderConfig;
            const props:any = deepCloneFlag?deepClone(findItem.sectionConfig):findItem.sectionConfig;
            props.label = props.label||(borderProps.title || findItem.label);
            if(labelStr){
              props.label = props.label + '['+labelStr+']'
            }
            targetObj.targetList.push({props});
          } else {
            //基础组件
            const deepFindItem:any=deepCloneFlag?deepClone(findItem):findItem;
            deepFindItem.props.label=(deepFindItem.props.label || deepFindItem.label);
            if(labelStr){
              deepFindItem.props.label= deepFindItem.props.label + '['+labelStr+']'
            }
            targetObj.targetList.push(deepFindItem);
          }
        })
      }
      unref(list).forEach((itemObj) => {
        if(itemObj.componentKey==='xmDrawer'&&winFlag===false){
          return;
        }
        if(itemObj.componentKey==='xmModal'&&winFlag===false){
          return;
        }
        if (itemObj && itemObj.children) {
          findCtls(itemObj.children, key, targetObj,labelStr,deepCloneFlag,winFlag);
        }
        //如果是xmStepWin组件 需要特殊处理
        if (itemObj && itemObj.tabDivConfig) {
          findCtls(itemObj.tabDivConfig.children, key, targetObj,labelStr,deepCloneFlag,winFlag);
        }
        //如果是xmStepWin组件 需要特殊处理
        if (itemObj && itemObj.props && itemObj.props.rightSlotItem) {
          findCtls(itemObj.props.rightSlotItem.children, key, targetObj, labelStr,deepCloneFlag,winFlag);
        }
      })
    }
  }catch (e){
    console.error(e,"===========e")
  }
}


export const findCtlsByType = function (list, ctlType, targetObj) {
  if (unref(list) && unref(list).length > 0 && Array.isArray(unref(list))) {
    const findItemList = unref(list).filter((itemDb) => {
      return itemDb.componentKey === ctlType;
    });
    if (findItemList && findItemList.length > 0) {
      findItemList.forEach((findItem) => {
        targetObj.targetList.push(findItem);
      })
    }
    unref(list).forEach((itemObj) => {
      if (itemObj && itemObj.children) {
        findCtlsByType(itemObj.children, ctlType, targetObj);
      }
      if (itemObj && itemObj.tabDivConfig && itemObj.tabDivConfig.children) {
        findCtlsByType(itemObj.tabDivConfig.children, ctlType, targetObj);
      }
      if (itemObj && itemObj.props && itemObj.props.rightSlotItem && itemObj.props.rightSlotItem.children) {
        findCtlsByType(itemObj.props.rightSlotItem.children, ctlType, targetObj);
      }
    })
  }
}

/**
 * 根据key查找元素
 * @param list
 * @param key
 * @param targetObj
 */
export const findCtlsByKey = function (list, key, targetObj) {
  if (unref(list) && unref(list).length > 0 && Array.isArray(unref(list))) {
    const findItemList = unref(list).filter((itemDb) => {
      return itemDb.key === key;
    });
    if (findItemList && findItemList.length > 0) {
      findItemList.forEach((findItem) => {
        targetObj.targetList.push(findItem);
      })
    }
    unref(list).forEach((itemObj) => {
      if (itemObj && itemObj.children) {
        findCtlsByKey(itemObj.children, key, targetObj);
      }
      if (itemObj && itemObj.tabDivConfig && itemObj.tabDivConfig.children) {
        findCtlsByKey(itemObj.tabDivConfig.children, key, targetObj);
      }
      if (itemObj && itemObj.props && itemObj.props.rightSlotItem && itemObj.props.rightSlotItem.children) {
        findCtlsByKey(itemObj.props.rightSlotItem.children, key, targetObj);
      }
    })
  }
}

/**
 * 获取控件对象集合
 * @param infoSettingJsonObj
 * @param ctlName
 */
export const getCtl = function (list: Array<any>, key: any, targetObj: any, propKey?: string) {
  const findItemList = unref(list).filter((itemDb) => {
    if (key && Array.isArray(key)) {
      return key.findIndex((val, index) => {
        if (propKey) {
          return val === itemDb.componentKey && itemDb.props.key === propKey;
        } else {
          return val === itemDb.componentKey;
        }
      }) >= 0;
    } else {
      if (propKey) {
        return itemDb.componentKey === key && itemDb.props.key === propKey;
      } else {
        return itemDb.componentKey === key;
      }
    }
  });
  const findItem = findItemList[0];
  if (findItem) {
    targetObj.target = findItem;
  }
  if (!targetObj.target) {
    unref(list).forEach((itemObj) => {
      if (itemObj && itemObj.children) {
        getCtl(itemObj.children, key, targetObj, propKey);
      }
      if (itemObj && itemObj.tabDivConfig && itemObj.tabDivConfig.children) {
        getCtl(itemObj.tabDivConfig.children, key, targetObj, propKey);
      }
      if (itemObj && itemObj.props && itemObj.props.rightSlotItem && itemObj.props.rightSlotItem.children) {
        getCtl(itemObj.props.rightSlotItem.children, key, targetObj, propKey);
      }
    })
  }
}
